'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chemist = require('chemist');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _flourishStyle = require('./flourishStyle.scss');

var _flourishStyle2 = _interopRequireDefault(_flourishStyle);

var _FormInput = require('../FormInput');

var _localisedPaths = require('../../helpers/localisedPaths');

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlourishRegistrationForm = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactCssModules2.default)(_flourishStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  (0, _inherits3.default)(FlourishRegistrationForm, _React$Component);

  function FlourishRegistrationForm() {
    (0, _classCallCheck3.default)(this, FlourishRegistrationForm);
    return (0, _possibleConstructorReturn3.default)(this, (FlourishRegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(FlourishRegistrationForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlourishRegistrationForm, [{
    key: 'render',
    value: function render() {
      var _context;

      var t = this.props.t;

      var lng = this.props.params.lng;
      var storeConfig = this.props.config.store;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'registrationOption registrationOption--login' },
          _react2.default.createElement(
            'div',
            { styleName: 'registrationOption__title', className: 't-title' },
            t('spree.login')
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'registrationOption__optionTitle', className: 't-h4' },
            t('login_with_email')
          ),
          _react2.default.createElement(
            _Form2.default,
            { action: (0, _localisedPaths.localisedPath)(storeConfig, 'updateLoginPath', lng), method: 'POST' },
            _react2.default.createElement(_FormInput.Input, {
              type: 'hidden',
              name: 'returnURL',
              value: (0, _localisedPaths.localisedAction)(storeConfig, 'checkout/address', lng)
            }),
            _react2.default.createElement(
              _FormInput.Label,
              { htmlFor: 'email' },
              t('spree.email')
            ),
            _react2.default.createElement(_FormInput.Input, { id: 'email', type: 'email', name: 'email', additionalStyles: '', required: true }),
            _react2.default.createElement(
              _FormInput.Label,
              { htmlFor: 'password' },
              t('spree.password')
            ),
            _react2.default.createElement(_FormInput.Input, {
              id: 'password',
              type: 'password',
              name: 'password',
              additionalStyles: '',
              required: true,
              pattern: '.{3}.*'
            }),
            _react2.default.createElement(
              'a',
              {
                styleName: 'registrationOption__forgotPassword',
                href: (0, _localisedPaths.localisedPath)(storeConfig, 'forgotPasswordPath', lng)
              },
              t('spree.forgot_password')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'registrationOption__formAction' },
              _react2.default.createElement(
                _FormInput.Button,
                { weight: 'secondary', styleName: 'registrationOption__login' },
                t('spree.login_and_continue')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'registrationOption registrationOption--guest' },
          _react2.default.createElement(
            'div',
            { styleName: 'registrationOption__title', className: 't-title' },
            t('spree.guest_checkout')
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'registrationOption__optionTitle', className: 't-h4' },
            t('spree.checkout_as_a_guest')
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'registrationOption__helpText' },
            t('spree.registration_not_obligatory')
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'registrationOption__formAction' },
            _react2.default.createElement(
              _FormInput.Button,
              { onClick: (_context = this.props).onGuestCheckout.bind(_context), weight: 'tertiary' },
              t('spree.continue_as_guest')
            )
          )
        )
      );
    }
  }]);
  return FlourishRegistrationForm;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = FlourishRegistrationForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/RegistrationForm/flourish.js
// module id = 2314
// module chunks = 0